import { useCallback, useRef } from 'react';

import { useEvent } from '~features/events/hooks/useEvent';

type TrackAiInsightsEvent<EventMap extends Record<string, unknown>> = <E extends keyof EventMap>(
  ...args: EventMap[E] extends void
    ? [event: E]
    : [event: E, properties: EventMap[E]]
) => void;

function useTrackAiInsightsEvent<EventMap extends Record<string, unknown>>(): TrackAiInsightsEvent<EventMap> {
  const { track } = useEvent();
  // useEvent().track is unstable (new ref every render). useRef keeps the callback
  // identity stable so consumers can safely list it as an effect dependency.
  const trackRef = useRef(track);
  trackRef.current = track;

  return useCallback<TrackAiInsightsEvent<EventMap>>(
    ((event: keyof EventMap, properties?: Record<string, unknown>) => {
      trackRef.current(event, properties ?? {});
    }) as TrackAiInsightsEvent<EventMap>,
    []
  );
}

export default useTrackAiInsightsEvent;
